import type { FC, ReactNode } from 'react';

import { Badge } from '@eneco/sparky';
import { BadgeProps } from '@eneco/sparky/types';

import { badgeWrapper, tileBarWrapper } from './TopTaskTileBar.css';

export const TileBarWrapper: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={tileBarWrapper}>{children}</div>
);

export const TopTaskBadge: FC<BadgeProps> = props => {
  return (
    <div className={badgeWrapper}>
      <Badge {...props} />
    </div>
  );
};
